import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import ViewDevices from "./ViewDeviceSubscription";
import CreateDevice from "./Create_device";
import MapDeviceSite from "./Map_device_to_site";

const steps = ["View Devices", "Create Device", "Map Device to Site"];

export default function ManageDevice() {
  const [activeStep, setActiveStep] = useState(0);

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <ViewDevices />;
      case 1:
        return <CreateDevice />;
      case 2:
        return <MapDeviceSite />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 1500,
        mx: "auto",
        py: 4,
        px: 2,
      }}
    >
      {/* Title */}
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: "bold",
          textAlign: "left",
          borderBottom: "2px solid #1976d2",
          display: "inline-block",
        }}
      >
        Manage Devices and Subscription
      </Typography>

      {/* Stepper */}
      <Card
        sx={{
          p: 1,
          mb: 2,
          borderRadius: 3,
          boxShadow: 4,
        }}
      >
        <Stepper activeStep={activeStep} alternativeLabel nonLinear>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                onClick={() => setActiveStep(index)}
                 StepIconProps={{
                  sx: {
                    cursor: "pointer",
                    fontWeight: "bold",
                    color: "grey.400",

                     "& .MuiStepIcon-text": {
        fill: "#000",
        fontWeight: "bold",
      },
                    "&.Mui-active": {
                       color: "#EE7F1A",
                      transform: "scale(1.3)",
                      transition: "all 0.3s",
                    },
                    "&.Mui-completed": {
                     color: "#EE7F1A",
                    },
                  },
                }}
                sx={{
                  cursor: "pointer",
                  "&:hover": { color: "primary.light", fontWeight: "bold" },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Card>

      {/* Animated Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeStep}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.4 }}
        >
          <Paper
            elevation={6}
            sx={{
              p: 1,
              borderRadius: 3,
              minHeight: 300,
              mb: 1,
              background: "linear-gradient(135deg, #bdbdbd 10%, #f8fafd 80%)",
            }}
          >
            {renderStepContent(activeStep)}
          </Paper>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
}